import {
    Marker,
    LeftTriangle,
    Text,
    RightTriangle,
    BtnWrapper
} from './style'
import { useState } from 'react';

export default (props) => {
    const [hover, setHover] = useState(false);

    const { txt, buttonAction, leftGradiant, rightGradiant, markerHeight, markerDeg, triangleHeight, sizeFont } = props;

    return (
        <BtnWrapper>
            { hover ? 
                <Marker
                    background={leftGradiant}
                    height={markerHeight}
                    rotation={markerDeg} 
                /> : null }
            <LeftTriangle
                background={leftGradiant}
                height={triangleHeight}
            />
            <Text
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                leftGradiant={leftGradiant}
                rightGradiant={rightGradiant}
                size={sizeFont}
                onClick={() => {
                    buttonAction()
            }}>{ txt }</Text>
            <RightTriangle
                background={rightGradiant}
                height={triangleHeight}
            />
            { hover ? 
                <Marker
                    background={rightGradiant}
                    right={'0px'}
                    height={markerHeight}
                    rotation={markerDeg} 
                /> : null }
        </BtnWrapper>
    )
}